









import VueOptions from '@utils/VueOptions'
import AudienceAvailabilityResourceList from '@hostComponents/AudienceAvailability/AudienceAvailabilityResourceList'

settings =
  name: 'AudienceAvailabilityList'

  resources:
    audience_availabilities:
      resourceName: 'audience_availability'
      slug: 'audience_availabilities'
      infinityScroll: true

  vue:
    components: {
      AudienceAvailabilityResourceList,
    }

    computed:
      actionsForAudienceAvailabilities: ->
        fetchResource: @fetchResource

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

export default VueOptions.vue settings
